import styled from 'styled-components';
import { FlexBetween, FlexColumn } from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';

export const LocationBarContainer = styled(FlexColumn)`
  > div:has(input) {
    background-color: ${({ theme }) => theme.colors.background.primary};

    &:focus-within {
      border-color: ${({ theme }) => theme.colors.systemColors.blue};
    }
  }

  gap: 15px;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    flex-direction: row;
    padding: 20px 25px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
    flex-wrap: wrap;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: 10px 40px 20px;
  }
`;

export const CityContainer = styled(FlexBetween)`
  height: 54px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 14px;
  padding: 10px 15px;
  cursor: pointer;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    width: 185px;
    padding: 10px;
    padding-left: 15px;
  }
`;

export const CityLabel = styled(Typography)``;
